import { render, staticRenderFns } from "./chanpin.vue?vue&type=template&id=19d18d82&scoped=true"
import script from "./chanpin.vue?vue&type=script&lang=js"
export * from "./chanpin.vue?vue&type=script&lang=js"
import style0 from "./chanpin.vue?vue&type=style&index=0&id=19d18d82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d18d82",
  null
  
)

export default component.exports